import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */

class Summary extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { content } = this.props;

        return (
            <div className={styles.summary}>
                <span>{content.leadtxt}</span>
                {content.url ? (
                    <span className={styles.cRed}>
                        <a href={content.url && content.url.replace('http://', 'https://')} target="_blank">
                            [新闻背景]
                        </a>
                    </span>
                ) : null}
            </div>
        );
    }
}

export default Summary;
